<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Clinic Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Clinic Details",
            items: [
               {
                  text: "Clinics",
                  href: "/clinics",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            clinic: { },
            bookings:"",
            clinic_location: '',
            clinic_marker: { position: { lat: null, lng: null } },
            clinic_center: { lat: null, lng: null },
            clinic_current_place: null,

            clinic_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            token: '',

            password: '',
            password_confirmation: '',
            new_pin: "",
            old_pin: "",

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchClinic();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchClinic() {
            let url = "api/admin/clinics/details?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.clinic = responseData.clinic;  
               this.bookings = responseData.bookings;  

               this.clinic_marker.position.lat = parseFloat(this.clinic.latitude);
               this.clinic_marker.position.lng = parseFloat(this.clinic.longitude);

               this.clinic_center.lat = parseFloat(this.clinic.latitude);
               this.clinic_center.lng = parseFloat(this.clinic.longitude);
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },  

         updatePin() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/change_pin";

            let formData = new FormData();
            formData.append("new_pin", this.new_pin); 
            formData.append("old_pin", this.old_pin); 
            formData.append("role_id", 4); 
            formData.append("id", this.$route.params.id); 
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('pin-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },
         updatePassword() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/clinics/password/change";

            let formData = new FormData();
            formData.append("id", this.$route.params.id); 
            formData.append("password", this.password); 
            formData.append("password_confirmation", this.password_confirmation); 
            
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('password-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 

         clearForm()   {
            this.password = "";
            this.password_confirmation = "";
            this.errors = {};
            this.new_pin = '';
            this.old_pin = '';
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="row">
                     <div class="col-lg-5 col-md-5">
                        <div class="card overflow-hidden">
                           <div class="bg-soft bg-primary">
                              <div class="row m-0">
                                 <div class="col-7">
                                 
                                 </div>
                                 <div class="col-5 align-self-end">
                                    
                                    <img  src="@/assets/images/profile-img.png" alt class="img-fluid" />
                                 </div>
                              </div>
                           </div>
                           <div class="card-body pt-2">
                              <div class="row">
                                 <div class="col-sm-4">
                                    <div class="avatar-md profile-user-wid mb-1">
                                       <img v-if="clinic.image" :src="$image_url + clinic.image" alt
                                       class="img-thumbnail rounded-circle">
                                       <img v-else src="@/assets/images/no-user.jpg"
                                       alt
                                       class="img-thumbnail rounded-circle"
                                       />
                                    </div>
                                    
                                 </div>
                                 <div class="col-sm-12 align-self-center">
                                    <h5 class="font-size-15">
                                       {{clinic.name}}
                                    </h5>
                                    <p class="font-size-14 mt-3 mb-1">
                                       <i class="bx bx-phone me-1 text-primary"></i> 
                                       {{clinic.country_code}} {{clinic.mobile}}
                                    </p>
                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-envelope me-1 text-primary"></i>
                                       {{clinic.username}}
                                    </p>

                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-map me-1 text-primary"></i>
                                       <span v-if="clinic.place">{{clinic.place}}</span>
                                    </p>
                                 </div>
                              </div>                              

                           </div>
                        </div>
                        <!-- <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 <tbody>                                    
                                    
                                    <tr>
                                       <th>Name</th>
                                       <th>:</th>
                                       <td>{{clinic.name}}</td>
                                    </tr>                                                       
                                    <tr>
                                       <th>Mobile</th>
                                       <th>:</th>
                                       <td>{{clinic.country_code}} {{clinic.mobile}}</td>
                                    </tr>           

                                    <tr>
                                       <th>Username</th>
                                       <th>:</th>
                                       <td>{{clinic.username}}</td>
                                    </tr>           
                                    
                                    <tr>
                                       <th>Place</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="clinic.place">{{clinic.place}}</span>
                                       </td>
                                    </tr>           
                                    
                                    <tr>
                                       <th>Status</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="clinic.status==1">Active</span>
                                          <span v-if="clinic.status==2">Blocked</span>
                                       </td>
                                    </tr>  
                                    
                                    <tr>
                                       <th>Created on</th>
                                       <th>:</th>
                                       <td>{{clinic.converted_created_at}}</td>
                                    </tr>           

                                 </tbody>
                              </table>
                           </div>
                        </b-card> -->

                        <div class="d-grid gap-2">
                           <b-button v-b-modal.password-modal block variant="primary">Change Password</b-button>
                           <b-button v-b-modal.pin-modal block variant="primary">Change Pin Number</b-button>
                           <router-link :to="{ name: 'clinics.edit', params: {id: $route.params.id} }" class="btn btn-primary">Edit Clinic</router-link>  
                        </div>
                        
                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-stethoscope font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Bookings</p>
                                 <h4 class="mb-0">{{bookings}}</h4>
                              </div>                              
                           </div>
                        </b-card>
                     </div>
                     <div class="col-lg-7 col-md-7">
                      
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Location</h4>
                           <b-row>                          

                           <b-col  md="12">
                           <div v-if="clinic.latitude || clinic.longitude">
                              <GmapMap
                                 :center="clinic_center"
                                 :zoom="18"
                                 map-style-id="clinic-roadmap"
                                 :options="clinic_mapOptions"
                                 style="width: 100%; height: 300px"
                                 ref="clinicMapRef"
                                 @click="clinicHandleMapClick">
                                    <GmapMarker
                                       :position="clinic_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="clinicHandleMarkerDrag"
                                       @click="clinicPanToMarker"
                                    />
                              </GmapMap>   
                              </div>  
                           </b-col>
                           </b-row>       
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Settings</h4>

                           <div class="table-responsive w-100">
                              <table class="table mb-0">
                                 <tbody>
                                    <tr>
                                       <th width="70%">Display Time in Token Vending Machine</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="clinic.display_token_time==1">Yes</span><span v-else>No</span></td>
                                    </tr> 
                                    <tr>
                                       <th width="70%">Display Name in Token Vending Machine</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="clinic.display_name==1">Yes</span><span v-else>No</span></td>
                                    </tr> 
                                    <tr>
                                       <th width="70%">Unlist from clinics listing</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="clinic.unlist==1">Yes</span><span v-else>No</span></td>
                                    </tr> 
                                 </tbody>
                              </table>
                           </div>
                        </b-card>                     
                     </div>
                  </div>
                  <!---- listing table ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="updatePassword()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">New Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                  <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password_confirmation"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                  <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>    
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
        <!---- modal starts ---->
        <b-modal ref="pin-modal" id="pin-modal" title="Change Pin Number" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="updatePin()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">Old Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="old_pin" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.old_pin) }"></b-form-input>

                  <div v-for="(val, index) in errors.old_pin" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">New Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="new_pin" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.new_pin) }"></b-form-input>

                  <div v-for="(val, index) in errors.new_pin" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>    
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                  <b-button class="" variant="light" @click="hideModal('pin-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
